import type { ClientSummary } from '@/types/client';
import type { User } from '@/types/user';

export function requiresInitialSetup(
  user?: Pick<User, 'type'> | null,
  clientSummary?: Pick<ClientSummary, 'onboarding_status'> | null
) {
  return user?.type === 'external' && clientSummary?.onboarding_status === 'pending';
}

export function shouldLeaveSetupRoute(
  user?: Pick<User, 'type'> | null,
  clientSummary?: Pick<ClientSummary, 'onboarding_status'> | null
) {
  return (
    user?.type === 'external' && !!clientSummary && clientSummary.onboarding_status !== 'pending'
  );
}

export function canFetchClientDetails(
  clientSummary?: Pick<ClientSummary, 'onboarding_status'> | null
) {
  return (
    clientSummary?.onboarding_status === 'partially_completed' ||
    clientSummary?.onboarding_status === 'completed'
  );
}
